import { createContext, use } from 'react';

export type Theme = 'light' | 'dark';

export interface ThemeContextValue {
  theme: Theme;
  setTheme: (theme: Theme) => void;
}

export const ThemeContext = createContext<ThemeContextValue | null>(null);

const FALLBACK_THEME: ThemeContextValue = {
  theme: 'light',
  setTheme: () => {},
};

export function useTheme() {
  const context = use(ThemeContext);
  return context ?? FALLBACK_THEME;
}
